export default __webpack_public_path__ + "static/media/paystubsMoneyIcon.6ede7cf1.svg";